import { Box } from '@mui/material';
import { memo } from 'react';
import type { SyberryTodayTaskId, SyberryTodayWorkItem } from 'domain/people/syberryToday/types';
import SyberryTodayTaskCard from '../SyberryTodayTaskCard/SyberryTodayTaskCard';

type SyberryTodayOrganizeTaskRowProps = {
  task: SyberryTodayWorkItem;
  isExpanded: boolean;
  onToggleExpansion: (taskId: SyberryTodayTaskId) => void;
};

const SyberryTodayOrganizeTaskRow = ({ task, isExpanded, onToggleExpansion }: SyberryTodayOrganizeTaskRowProps) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: 1.5, alignItems: 'start' }}>
    <SyberryTodayTaskCard task={task} isExpanded={isExpanded} isSelectionHidden onToggleExpansion={onToggleExpansion} />
  </Box>
);

export default memo(SyberryTodayOrganizeTaskRow);
